import Link from 'next/link'
import CustomButton, { BUTTON_TYPES } from '@/components/ui/button'
import InfoCard from '../index'
import PopoverWithLink from '@/components/ui/popover/with-link'
import { memo } from 'react'
import styles from './styles.module.css'

const InfoCardWithButton = ({ card: { btn, link, ...prop } }) => {
  return (
    <div className={styles.cardWithBtnColumn}>
      <InfoCard card={prop} />
      <Link href={btn.link}>
        <a rel="nofollow" className={styles.buttonContainer}>
          <CustomButton type={BUTTON_TYPES.BLUE} text={btn.text} />
        </a>
      </Link>
      {link && (
        <>
          {link.info ? (
            <PopoverWithLink info={link.info}>
              <Link href={link.href}>
                <a rel="nofollow" className={styles.linkText}>
                  {link.text}
                </a>
              </Link>
            </PopoverWithLink>
          ) : (
            <Link href={link.href}>
              <a rel="nofollow" className={styles.linkText}>
                {link.text}
              </a>
            </Link>
          )}
        </>
      )}
    </div>
  )
}

export default memo(InfoCardWithButton)
